import React from 'react';
import { Table } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import './VerifiedCallerIdRow.css';

const getStatusBadgeClass = (status) => {
  switch ((status || '').toLowerCase()) {
    case 'verified':
    case 'approved':
      return 'badge-success';
    case 'pending':
    case 'verification-pending':
      return 'badge-warning';
    case 'failed':
    case 'verification-failed':
      return 'badge-danger';
    default:
      return 'badge-info';
  }
};

const getStatusLabel = (status) => {
  switch ((status || '').toLowerCase()) {
    case 'verified':
    case 'approved':
      return 'Verified';
    case 'pending':
    case 'verification-pending':
      return 'Pending';
    case 'failed':
    case 'verification-failed':
      return 'Failed';
    default:
      return status || 'Unknown';
  }
};

const getMethodLabel = (method) => {
  switch ((method || '').toLowerCase()) {
    case 'call':
      return 'Phone Call';
    case 'sms':
      return 'SMS';
    default:
      return method || '—';
  }
};

export const VerifiedCallerIdRow = props => {
    const callerId = props.callerId;
    const isPending = ['pending', 'verification-pending', 'failed'].includes((callerId.verification_status || callerId.status || '').toLowerCase());

    return (
        <Table.Row>
            <Table.Cell>
                {''}
            </Table.Cell>
            <Table.Cell style={{ whiteSpace: "nowrap" }}>
                <div className="phone-number-main">{callerId.formatted_phone || callerId.phone_number || callerId.twilio_phone || 'N/A'}</div>
            </Table.Cell>
            <Table.Cell>
                {callerId.friendly_name || '—'}
            </Table.Cell>
            <Table.Cell>
                <span className="status-badge badge-info">
                  {getMethodLabel(callerId.verification_method)}
                </span>
            </Table.Cell>
            <Table.Cell>
                <span className={`status-badge ${getStatusBadgeClass(callerId.verification_status || callerId.status)}`}>
                  {getStatusLabel(callerId.verification_status || callerId.status)}
                </span>
            </Table.Cell>
          
            <Table.Cell>
                <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                  {props.onResendOtp && isPending && (
                    <button
                      className="btn linear-gradient yr-submitbtn"
                      onClick={() => !props.resending && props.onResendOtp(callerId)}
                      disabled={props.resending}
                    >
                      {props.resending ? 'Sending...' : 'Resend Call'}
                    </button>
                  )}
                  {props.onDelete && (
                    <button
                      className="btn linear-gradient yr-submitbtn"
                      onClick={() => !props.loading && props.onDelete(callerId)}
                      disabled={props.loading}
                    >
                      Delete
                    </button>
                  )}
                </div>
            </Table.Cell>
        </Table.Row>
    );
};

VerifiedCallerIdRow.propTypes = {
    callerId: PropTypes.object.isRequired,
    onDelete: PropTypes.func,
    onResendOtp: PropTypes.func,
    loading: PropTypes.bool,
    resending: PropTypes.bool,
};
